import type React from 'react';

import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';

import { ReactComponent as LogoInstagram } from 'assets/images/instagram-logo.svg';
import { ReactComponent as LogoInstagramVariant } from 'assets/images/logo-instagram-variant.svg';
import { ReactComponent as LogoMessengerVariant } from 'assets/images/logo-messenger-variant.svg';
import { ReactComponent as LogoMessenger } from 'assets/images/logo-messenger.svg';
import {
  ReactComponent as LogoTelegramVariant,
  ReactComponent as LogoTelegram,
} from 'assets/images/logo-telegram.svg';
import { ReactComponent as LogoWhatsAppOfficialVariant } from 'assets/images/logo-whatsapp-oficial-variant.svg';
import { ReactComponent as LogoWhatsAppOfficial } from 'assets/images/logo-whatsapp-oficial.svg';
import { ReactComponent as LogoWhatsappVariant } from 'assets/images/logo-whatsapp-variant.svg';
import { ReactComponent as LogoWhatsapp } from 'assets/images/logo-whatsapp.svg';
import { TipoCanalEnum } from 'store/reducers/canais';

export {
  LogoInstagramVariant,
  LogoMessengerVariant,
  LogoTelegramVariant,
  LogoWhatsappVariant,
  LogoWhatsAppOfficialVariant,
  LogoInstagram,
  LogoMessenger,
  LogoTelegram,
  LogoWhatsapp,
  LogoWhatsAppOfficial,
};

type SvgProps = React.SVGProps<SVGSVGElement>;

export interface ChannelIconConfig {
  icon: React.ComponentType<SvgProps> | React.ComponentType;
  iconVariant: React.ComponentType<SvgProps> | React.ComponentType;
  color: string;
  label?: string;
}

export const UNKNOWN_CHANNEL_CONFIG: ChannelIconConfig = {
  icon: ErrorOutlineIcon,
  color: '#ED6C02',
  label: 'Canal desconhecido',
  iconVariant: ErrorOutlineIcon,
};

export const CHANNEL_ICON_CONFIG: Record<TipoCanalEnum, ChannelIconConfig> = {
  WHATSAPP_OFICIAL: {
    icon: LogoWhatsAppOfficial,
    iconVariant: LogoWhatsAppOfficialVariant,
    color: '#00921A',
  },
  WHATSAPP: {
    icon: LogoWhatsapp,
    iconVariant: LogoWhatsappVariant,
    color: '#00921A',
  },
  INSTAGRAM: {
    icon: LogoInstagram,
    iconVariant: LogoInstagramVariant,
    color: '#610099',
  },
  MESSENGER: {
    icon: LogoMessenger,
    iconVariant: LogoMessengerVariant,
    color: '#0866FF',
  },
  TELEGRAM: {
    icon: LogoTelegram,
    iconVariant: LogoTelegram,
    color: '#7bacfcff',
  },
};
